import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
// import ProstateDecisionButton from "./ProstateDecisionButton";
// import PrintViewResult from "../PrintViewResult";
import MainLayout from "../../components/layout/MainLayout";
import CancerLastHeader from "../../components/layout/Header/CancerLastHeader";
import CancerPrintFooter from "../../components/layout/Footer/CancerPrintFooter";
import ProstateDecisionSmall from "./ProstateDecisionSmall";
// import LungDecisionSmall from "./LungDecisionSmall";

import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 100,
  },
  title: {
    marginBottom: 18,
  },
  regular: {
    fontWeight: 400,
  },
  bold: {
    fontWeight: 600,
  },

  body: {
    marginTop: 0,
    marginBottom: 30,
    // height: 200,
  },
  bodybol: {
    marginTop: 32,
    marginBottom: 32,
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
  },
  backButton: {
    width: 432,
    height: 78,
    fontSize: 20,
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },

  footer: {
    marginTop: 12,
    marginBottom: 36,
  },
  headerLine: {
    width: 480,
  },
  headerSubLine: {
    flex: 1,
  },
  table: {
    height: 373,
    border: "1px solid #e3e3e3",
    backgroundColor: "#ffffff",
  },
  borderLeft: {
    borderLeft: "1px solid #ffffff",
  },
  borderLeft2: {
    borderLeft: "1px solid #e3e3e3",
  },
  borderBottom: {
    borderBottom: "1px solid #e3e3e3",
  },
  defaultHeight: {
    width: "100%",
    height: 70,
  },
  multiHeight: {
    width: "100%",
    height: 93,
  },
  titleName: {
    fontSize: 22,
    color: "#333333",
  },
  blueColor: {
    background: "#dee8f4",
  },
  blueText: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  large: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    backgroundColor: theme.palette.background.paper,
    padding: 24,
  },
}));

const forData = [
  {
    no: 1,
    text: "치료가 가능한 시기의 전립선암을 조기에 발견",
    list: ["a", "b", "c", "d"],
  },
  {
    no: 2,
    text: "검사 과정에서 가짜 양성의 결과가 나올 수 있음",
    list: ["a", "b", "c", "d"],
  },
  {
    no: 3,
    text: "검사로 인한 부작용 (조직검사로 인한 합병증 발생)",
    list: ["a", "b", "c", "d"],
  },
  { no: 4, text: "확진을 위한 검사중 합병증 발생", list: ["a", "b", "c", "d"] },
];
const caseText = ["매우 중요", "중요", "약간 중요", "중요하지 않음"];

const ProstateDecision = ({
  cancer = "전립선암",
  onViChange,
  vi,
  prostateRe,
  total,
  complete,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [question1, setQuestion1] = useState("a");
  const [question2, setQuestion2] = useState("a");
  const [question3, setQuestion3] = useState("a");
  const [question4, setQuestion4] = useState("a");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // 다음으로 페이지 이동
  const handlePageMove = () => {
    // handleOpen();
    history.replace('/')
    // alert("준비중입니다.");
  };
  const handleChange = (num = 1, event) => {
    if (num === 1) {
      setQuestion1(event.target.value);
    } else if (num === 2) {
      setQuestion2(event.target.value);
    } else if (num === 3) {
      setQuestion3(event.target.value);
    } else if (num === 4) {
      setQuestion4(event.target.value);
    }
  };
  const queData = {
    que1: question1,
    que2: question2,
    que3: question3,
    que4: question4,
  };

  const handleNotComple = () => {
    alert(`'나의 전립선암 발생 위험도 계산하기' 를 작성후 이용 가능합니다.`);
    return false;
  };
  const handleSearch = () => {
    history.push("/evaluation/prostate");
  };
  return (
    // <Grid container justify="center" alignItems="center" direction="column">
    <>
      <MainLayout
        header={<CancerLastHeader cancer={cancer} sub={true} />}
        footer={
          <CancerPrintFooter
            cancer={cancer}
            complete={complete}
            lungRe={prostateRe}
            total={total}
            queData={queData}
            handleNotComple={handleNotComple}
            handlePageMove={handlePageMove}
            handlePrevMove={() => { onViChange(1); }}
          />
        }
      >
        <Grid
          container
          className={classes.body}
          justify="space-between"
          alignItems="center"
          direction="column"
        >
          <Grid className={classes.small}>
            <ProstateDecisionSmall
              question1={question1}
              question2={question2}
              question3={question3}
              question4={question4}
              handleChange={handleChange}
              forData={forData}
              caseText={caseText}
            />
          </Grid>
          <Grid
            container
            alignItems="center"
            justify="center"
            className={clsx(classes.large, classes.table)}
          >
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              className={clsx(classes.headerLine)}
            >
              <Grid className={clsx(classes.defaultHeight, classes.blueColor)}>
                <Typography variant="h4" align="left"></Typography>
              </Grid>
              <Grid
                container
                alignItems="center"
                className={clsx(classes.defaultHeight, classes.borderBottom)}
              >
                <Typography variant="h4" align="left">
                  &nbsp;&nbsp;치료가 가능한 시기의 전립선암을 조기에 발견
                </Typography>
              </Grid>
              <Grid
                container
                alignItems="center"
                className={clsx(classes.defaultHeight, classes.borderBottom)}
              >
                <Typography variant="h4" align="left">
                  &nbsp;&nbsp;검사 과정에서 가짜 양성의 결과가 나올 수 있음
                </Typography>
              </Grid>
              <Grid
                container
                alignItems="center"
                className={clsx(classes.multiHeight, classes.borderBottom)}
              >
                <Typography variant="h4" align="left">
                  &nbsp;&nbsp;검사로 인한 부작용
                  <br />
                  &nbsp;&nbsp;(조직검사로 인한 합병증 발생)
                </Typography>
              </Grid>
              <Grid
                container
                alignItems="center"
                className={clsx(classes.defaultHeight)}
              >
                <Typography variant="h4" align="left">
                  &nbsp;&nbsp;확진을 위한 검사중 합병증 발생
                </Typography>
              </Grid>
            </Grid>
            <Grid className={clsx(classes.headerSubLine)}>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.blueColor,
                  classes.borderLeft
                )}
              >
                <Typography variant="h5" align="center">
                  매우 중요
                </Typography>
              </Grid>
              <Grid
                container
                alignItems="center"
                justify="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question1 === "a"}
                  onChange={(e) => handleChange(1, e)}
                  value="a"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "A" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question2 === "a"}
                  onChange={(e) => handleChange(2, e)}
                  value="a"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "A" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.multiHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question3 === "a"}
                  onChange={(e) => handleChange(3, e)}
                  value="a"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "A" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(classes.defaultHeight, classes.borderLeft2)}
              >
                <Radio
                  checked={question4 === "a"}
                  onChange={(e) => handleChange(4, e)}
                  value="a"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "A" }}
                />
              </Grid>
            </Grid>
            <Grid className={clsx(classes.headerSubLine)}>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.blueColor,
                  classes.borderLeft
                )}
              >
                <Typography variant="h5" align="center">
                  중요
                </Typography>
              </Grid>
              <Grid
                container
                alignItems="center"
                justify="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question1 === "b"}
                  onChange={(e) => handleChange(1, e)}
                  value="b"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "B" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question2 === "b"}
                  onChange={(e) => handleChange(2, e)}
                  value="b"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "B" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.multiHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question3 === "b"}
                  onChange={(e) => handleChange(3, e)}
                  value="b"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "B" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(classes.defaultHeight, classes.borderLeft2)}
              >
                <Radio
                  checked={question4 === "b"}
                  onChange={(e) => handleChange(4, e)}
                  value="b"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "B" }}
                />
              </Grid>
            </Grid>
            <Grid className={clsx(classes.headerSubLine)}>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.blueColor,
                  classes.borderLeft
                )}
              >
                <Typography variant="h5" align="center">
                  약간 중요
                </Typography>
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question1 === "c"}
                  onChange={(e) => handleChange(1, e)}
                  value="c"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "C" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question2 === "c"}
                  onChange={(e) => handleChange(2, e)}
                  value="c"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "C" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.multiHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question3 === "c"}
                  onChange={(e) => handleChange(3, e)}
                  value="c"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "C" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(classes.defaultHeight, classes.borderLeft2)}
              >
                <Radio
                  checked={question4 === "c"}
                  onChange={(e) => handleChange(4, e)}
                  value="c"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "C" }}
                />
              </Grid>
            </Grid>
            <Grid className={clsx(classes.headerSubLine)}>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.blueColor,
                  classes.borderLeft
                )}
              >
                <Typography variant="h5" align="center">
                  중요하지
                  <br />
                  않음
                </Typography>
              </Grid>
              <Grid
                container
                alignItems="center"
                justify="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question1 === "d"}
                  onChange={(e) => handleChange(1, e)}
                  value="d"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "D" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.defaultHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question2 === "d"}
                  onChange={(e) => handleChange(2, e)}
                  value="d"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "D" }}
                />
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={clsx(
                  classes.multiHeight,
                  classes.borderBottom,
                  classes.borderLeft2
                )}
              >
                <Radio
                  checked={question3 === "d"}
                  onChange={(e) => handleChange(3, e)}
                  value="d"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "D" }}
                />
              </Grid>
              <Grid
                container
                alignItems="center"
                justify="center"
                className={clsx(classes.defaultHeight, classes.borderLeft2)}
              >
                <Radio
                  checked={question4 === "d"}
                  onChange={(e) => handleChange(4, e)}
                  value="d"
                  name="radio-buttons"
                  color="primary"
                  inputProps={{ "aria-label": "D" }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MainLayout>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.modal}>
          <Typography id="modal-modal-title" variant="h4">
            귀하께서는
            <br />
            <span className={classes.blueText}>
              {cancer} 검진을 받는 것이 좋을까요?
            </span>
            <br />
            시청을 마치셨습니다.
            <br />
            시청하신 자료에 대한 간단한 설문에 응답을 부탁드립니다.
          </Typography>
          <Grid
            container
            justify="center"
            alignItems="center"
            style={{ marginTop: 24 }}
          >
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={handleSearch}
            >
              설문참여
            </Button>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    prostateRe: state.prostateRe.prostateData,
    total: state.prostateRe.total,
    complete: state.prostateRe.complete,
  };
};
export default connect(
  // 스토어와 연결
  mapStateToProps
)(ProstateDecision);
// export default LungDecision;
